import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { hideAlert } from "store/reducers/alertReducer"
import Swal from "sweetalert2"

const ICON_MAP = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
  question: "question",
  failed: "error",
}

const DEFAULT_TIMER_MS = 3000

const SweatAlert = ({ text, type, nonce, duration }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const icon = ICON_MAP[type] || "info"
    // Most toasts use the default; a caller can pass a longer duration for
    // an unusually important message (e.g. session-replaced) that the user
    // needs more time to read before anything else happens (like a redirect).
    const timer = duration || DEFAULT_TIMER_MS

    Swal.fire({
      toast: true,
      icon,
      title: text,
      position: "top-end",
      showConfirmButton: false,
      timer,
      timerProgressBar: true,
      customClass: {
        popup: "app-toast",
        title: "app-toast-title",
        icon: "app-toast-icon",
      },
    })

    const timeout = setTimeout(() => {
      dispatch(hideAlert())
    }, timer)

    return () => {
      clearTimeout(timeout)
    }
    // `nonce` is included so repeated dispatches of the same text/type
    // (e.g. consecutive "Wrong Password!" toasts) still re-fire the toast.
  }, [dispatch, text, type, nonce, duration])

  return null
}

export default SweatAlert
